import { MouseEventHandler, ReactNode } from "react";
import clsx from "clsx";

// MUI
import { IconButton, Paper, Stack } from "@mui/material";

// Icons
import CircularProgress from "@mui/material/CircularProgress";

type SimpleIconButtonProps = {
	ariaLabel?: string;
	className?: string;
	color?: string;
	disabled?: boolean;
	icon: ReactNode;
	iconHover?: ReactNode;
	loading?: boolean;
	loadingIcon?: string;
	loadingSize?: number;
	onClick?: MouseEventHandler<HTMLButtonElement>;
	size?: "small" | "medium" | "large";
	sx?: object;
	sxLoading?: object;
};
export default function SimpleIconButton(props: Readonly<SimpleIconButtonProps>) {
	const { className = "" } = props;

	return (
		<IconButton
			aria-label={props.ariaLabel ?? "Button"}
			size={props.size ?? "medium"}
			className={clsx({
				[className]: true,
				"simple-icon-button": true,
			})}
			disabled={props.disabled || props.loading || false}
			sx={props.sx}
			style={{ color: props.color }}
			onClick={props.onClick}
		>
			{props.loading ? (
				<>
					{props.loadingIcon ? (
						<Stack justifyContent={"center"} alignItems={"center"} sx={{ width: "35px", height: "35px" }}>
							<img src={props.loadingIcon} alt="loading..." width={props.loadingSize ?? 30} />
						</Stack>
					) : (
						<Paper elevation={0} className={"regular-icon"} sx={props.sxLoading}>
							<CircularProgress color="inherit" size={props.loadingSize ?? 35} />
						</Paper>
					)}
				</>
			) : (
				<>
					<Paper elevation={0} className={"regular-icon"}>
						{props.icon}
					</Paper>
					{props.iconHover ? (
						<Paper elevation={0} className={"hover-icon"}>
							{props.iconHover}
						</Paper>
					) : (
						<Paper elevation={0} className={"hover-icon"}>
							{props.icon}
						</Paper>
					)}
				</>
			)}
		</IconButton>
	);
}
